import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'lib-shared',
    template: `
    <p>
      shared works 123!
    </p>
  `,
    styles: [],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class SharedComponent {

}
